<template>
<pop-up-layout 
  :title="$t('promociones.img')"
  :description="$t('promociones.textoImg', {imagen: promocion.descripcion})"
  :aceptar="$t('general.misc.guardarCambios')"
  :loading="loading"
  :saving="waitingForLoad"
  :loadingText="$t('general.misc.cargando')"
  :disabled="!cambiado"
  @volver="$parent.hide()"
  @aceptar="guardar()"
>
  <v-layout column justify-center align-center my-4>
    <FileUploader
      :subPopUp="true"
      style="height:168px; width: 200px"
      :maxNum="1"
      v-model="documentoImagen"
      :deletable="true"
      accept="image/*"
      :imagesOnly="true"
    />
  </v-layout>
</pop-up-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FileUploader from '@/components/generic/fileUploader/FileUploader'

export default {
  components: {
    FileUploader
  },
  props: {
    codigoPromocion: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      waitingForLoad: false,
      cambiadoData: false,
      documentoImagen: [],
      loading: true
    }
  },
  async created () {
    try {
      this.loading = true
      await this.loadPromocion(this.codigoPromocion)
      if (this.promocion.documentoImagen.length > 0) {
        this.documentoImagen.push(Object.assign({}, this.promocion.documentoImagen[0].documento))
      }
      this.cambiadoData = false
      this.loading = false
      this.$emit('cambiado', false)
    } catch (error) {
      this.waitingForLoad = false
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  beforeDestroy () {
    this.$emit('cambiado', false)
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  computed: {
    ...mapGetters({
      promocion: 'promociones/getActual'
    }),
    cambiado () {
      if (this.cambiadoData) {
        return true
      }
      // eslint-disable-next-line
      this.cambiadoData = this.cambiadoData || this.documentoImagen.length !== this.promocion.documentoImagen.length
      this.$emit('cambiado', this.cambiadoData)
      return this.cambiadoData
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadPromocion: 'promociones/loadPromocion',
      modificarImagenPromocion: 'promociones/modificarImagen'
    }),
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    async guardar () {
      try {
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        await this.modificarImagenPromocion({
          codigoPromocion: this.promocion.codigo,
          documentoImagen: this.documentoImagen.length > 0 ? this.documentoImagen : null
        })
        this.$emit('cambiado', false)
        this.$emit('recargar')
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        this.addAlert({texto: this.$t('general.misc.cambiosGuardadosExito'), color: 'success'})
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/promociones/PopUpImagenPromocion.vue